import React, { useState } from "react";
import { Input } from "antd";
import FeedbackReports from "./FeedbackReports";

const { Search } = Input;

const ReportFeedbackLanding = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (value) => {
    setSearchQuery(value.toLowerCase());
  };

  return (
    <div className="page-wrapper-full">
      <div className="content container-fluid">
        <div className="page-header d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 className="page-title" style={{ fontSize: "24px", fontWeight: "600" }}>
              Feedback Reports
            </h3>
            <p className="page-subtitle" style={{ fontSize: "14px", color: "#666" }}>
              Explore insights from customer feedback to improve service and loyalty.
            </p>
          </div>
          <div className="filter-section">
            <Search
              placeholder="Search reports..."
              allowClear
              enterButton
              onSearch={handleSearch}
              style={{ width: "300px" }}
            />
          </div>
        </div>
        <div className="form-bg" style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px" }}>
          <FeedbackReports searchQuery={searchQuery} />
        </div>
      </div>
    </div>
  );
};

export default ReportFeedbackLanding;